(() => {
  const url = '/pages/reviews';
  const insert = () => {
    const menus = document.querySelectorAll('.header__inline-menu ul.list-menu, .menu-drawer__menu');
    menus.forEach((menu) => {
      if ([...menu.querySelectorAll('a')].some((link) => link.textContent.trim() === 'Reviews')) return;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = url;
      link.textContent = 'Reviews';
      link.className = menu.classList.contains('menu-drawer__menu')
        ? 'menu-drawer__menu-item list-menu__item link link--text focus-inset'
        : 'header__menu-item list-menu__item link link--text focus-inset';
      if (window.location.pathname.replace(/\/$/, '') === url) {
        link.setAttribute('aria-current', 'page');
      }
      item.appendChild(link);
      menu.appendChild(item);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insert, { once: true });
  } else {
    insert();
  }
})();
